import { environment } from '../../../environments/environment';
import { HttpClient, } from '@angular/common/http';
import { SystemService } from '../../service/system.service';
var wicService = (function () {
    function wicService(http) {
        this.http = http;
        this.dataModelUrl = '';
        var systemService = new SystemService();
        if (environment && environment.properties) {
            this.dataModelUrl = systemService.getDataModelUrl();
        }
    }
    wicService.prototype.getWicData = function () {
        var url = this.dataModelUrl + "wic_dashboard?sort={\"_id\":-1}&pagesize=1&filter={}";
        return this.http.get(url)
            .toPromise()
            .then(function (response) {
            if (response && response[0]) {
                return response;
            }
            return [];
        })
            .catch(function (reason) {
            console.error(reason);
        });
    };
    return wicService;
}());
export { wicService };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/services/wic/wic.service.ts.pre-build-optimizer.js